<template>
  <div>

    <b-tabs content-class="mt-1">
      <b-tab title="Book">
        <b-form @submit.prevent>
          <b-row>

            <!-- first name -->
            <b-col cols="12">
              <b-form-group
                label="Book ID"
                label-for="vi-id"
              >
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="BookIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    id="vi-id"
                    v-model="book.id"
                    placeholder="Book Id"
                    disabled="disabled"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group
                label="Title"
                label-for="vi-title"
              >
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="EditIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    id="vi-title"
                    v-model="book.title"
                    placeholder="Book Title"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group
                label="Author"
                label-for="vi-author"
              >
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="EditIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    id="vi-title"
                    v-model="book.author"
                    placeholder="Book Author"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group
                label="Publisher"
                label-for="vi-publisher"
              >
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="EditIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    id="vi-title"
                    v-model="book.publisher"
                    placeholder="Book Publisher"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group
                label="Download URL"
                label-for="vi-url"
              >
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="LinkIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    id="vi-url"
                    v-model="book.url"
                    placeholder="Book URL"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group
                label="Detail URL"
                label-for="vi-details-url"
              >
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="LinkIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    id="vi-details-url"
                    v-model="book.bookDetailsURL"
                    placeholder="Book URL"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group
                label="Free Path"
                label-for="vi-free-path"
              >
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="LinkIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    id="vi-free-path"
                    v-model="book.freePath"
                    placeholder="Book free path"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group
                label="IapBookId"
                label-for="vi-iapBookId"
              >
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="LinkIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    id="vi-iapBookId"
                    v-model="book.iapBookId"
                    placeholder="Book iapBookId"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group
                label="Icon"
                label-for="vi-path"
              >
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="LinkIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    id="vi-icon"
                    v-model="book.icon"
                    placeholder="Book icon"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <img
                :src="book.icon"
                style="margin-bottom: 10px"
              >
            </b-col>

            <b-col cols="12">
              <b-form-group
                label="Status"
                label-for="vi-status"
              >
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="EditIcon" />
                  </b-input-group-prepend>
                  <b-form-select
                    id="vi-status"
                    v-model="book.status"
                    :options="statuses"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group
                label="Upload Date (dd/mm/yyyy) "
                label-for="vi-upload-date"
              >
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="LinkIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    id="vi-upload-date"
                    v-model="book.dateUploaded"
                    placeholder="Upload Date ( format: dd/mm/yyyy )"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group
                label="Password"
                label-for="vi-password"
              >
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="KeyIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    id="vi-password"
                    v-model="book.password"
                    placeholder="Password"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>

            <!-- checkbox -->
            <b-col cols="12">
              <b-form-group>
                <b-form-checkbox
                  id="checkbox-4"
                  v-model="book.puzzle"
                  name="checkbox-4"
                  value="true"
                >
                  Puzzle
                </b-form-checkbox>
              </b-form-group>
            </b-col>

            <!-- checkbox -->
            <b-col cols="12">
              <b-form-group>
                <b-form-checkbox
                  id="sample"
                  v-model="book.sample"
                  name="sample"
                  value="true"
                >
                  List as Sample book
                </b-form-checkbox>
              </b-form-group>
            </b-col>

            <!-- checkbox -->
            <b-col cols="12">
              <b-form-group>
                <b-form-checkbox
                  id="bestSeller"
                  v-model="book.bestSeller"
                  name="bestSeller"
                  value="true"
                >
                  Best Seller
                </b-form-checkbox>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <div style="padding-bottom: 10px">
                <span style="font-weight: bold;padding-bottom: 10px">Created At: {{ formatDate(book.created) }}</span>,  Last update: {{ formatDate(book.updated) }}
              </div>
            </b-col>
            <!-- reset and submit -->
            <div class="demo-inline-spacing">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1"
                @click="saveBook"
              >
                Save
              </b-button>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="danger"
                class="mr-1"
                @click="askDelete"
              >
                Delete
              </b-button>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="success"
                class="mr-1"
                @click="sync"
              >
                Sync Files
              </b-button>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="success"
                class="mr-1"
                @click="clearCache"
              >
                Clear Cache
              </b-button>
            </div>
          </b-row>
        </b-form>
      </b-tab>

      <b-tab title="Reviews">
        <b-button
          v-b-modal.modal-add-review
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          type="submit"
          variant="success"
          class="mr-1"
        >
          Add
        </b-button>
        <DataTable
          ref="reviewsTable"
          :api="reviewsUrl"
          :on-row-selected-callback="onReviewSelected"
        />
      </b-tab>

      <b-tab
        title="In-App Purchases"
        lazy
      >
        <BookIaps
          v-if="book.id"
          :book="book"
        />
      </b-tab>
    </b-tabs>

    <b-modal
      id="modal-add-review"
      cancel-variant="outline-secondary"
      ok-title="Save"
      cancel-title="Close"
      centered
      size="lg"
      title="Add/Save Review"
      @ok="addReview"
    >
      <b-form>
        <b-form-group>
          <label>Account Email:</label>
          <b-form-input
            id="email"
            v-model="review.email"
            placeholder="Email"
          />
        </b-form-group>
        <b-form-group>
          <label>Title:</label>
          <b-form-input
            id="reviewTitle"
            v-model="review.title"
            placeholder="Title"
          />
        </b-form-group>
        <b-form-group>
          <label>Rating:</label>
          <star-rating
            v-model="review.rating"
            :rating="1"
            :increment="1"
          />
        </b-form-group>
        <b-form-group>
          <b-form-checkbox
            id="approved"
            v-model="review.approved"
            name="approved"
          >
            Approved
          </b-form-checkbox>
        </b-form-group>
        <b-form-group>
          <label for="description">Description:</label>
          <quill-editor
            id="description"
            v-model="review.description"
            :options="snowOption"
          />
        </b-form-group>
      </b-form>
    </b-modal>

  </div>
</template>

<script>
import axios from 'axios'
import firebase from 'firebase/app'
import 'firebase/auth'
import { quillEditor } from 'vue-quill-editor'
import StarRating from 'vue-star-rating'
import DataTable from '@core/components/data-table/DataTable.vue'
import BookIaps from './BookIaps.vue'
import {
  BRow, BCol, BFormGroup, BFormInput, BFormCheckbox, BForm, BButton, BInputGroup, BInputGroupPrepend, BFormSelect, BTabs, BTab,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    DataTable,
    BookIaps,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BFormSelect,
    BTabs,
    BTab,
    quillEditor,
    StarRating,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      snowOption: {
        theme: 'snow',
      },
      book: {},
      review: {
        title: '', description: '', rating: 5, approved: false, id: undefined,
      },
      reviewsUrl: `/admin/books/${this.$route.params.book}/reviews`,
      statuses: [
        { value: 'NORMAL', text: 'NORMAL' },
        { value: 'WEBSPECIAL', text: 'WEBSPECIAL' },
        { value: 'HIDDEN', text: 'HIDDEN' },
        { value: 'DELETED', text: 'DELETED' },
      ],
    }
  },
  mounted() {
    const url = `${this.$readerURL}/admin/books/${this.$route.params.book}`
    this.loader('block')
    firebase.auth().currentUser.getIdToken(false).then(idToken => {
      axios.get(url,
        {
          headers: {
            Authorization: idToken,
          },
        }).then(response => {
        this.book = response.data

        this.loader('none')
        return response
      }).catch(error => {
        this.loader('none')
        this.$bvModal
          .msgBoxOk(`Book not found: ${error}`, {
            title: 'Info',
            size: 'sm',
            okVariant: 'danger',
            okTitle: 'Close',
            hideHeaderClose: false,
            centered: true,
          })
          .then(value => {
            this.$router.push('/books')
            return value
          })
      })
    })
  },
  methods: {
    onReviewSelected(id) {
      if (id.length > 0) {
        this.loader('block')
        const url = `${this.$readerURL}/admin/reviews/${id[0].id}`
        firebase.auth().currentUser.getIdToken(false).then(idToken => {
          axios.get(url,
            {
              headers: {
                Authorization: idToken,
              },
            }).then(response => {
            this.loader('none')

            this.review.email = response.data.email
            this.review.id = response.data.id
            this.review.title = response.data.title
            this.review.description = response.data.description
            this.review.approved = response.data.approved
            this.review.rating = response.data.rating
            this.$bvModal.show('modal-add-review')
            return response
          }).catch(error => {
            this.loader('none')
            this.$toast({
              component: ToastificationContent,
              props: {
                title: error,
                icon: 'EditIcon',
                variant: 'error',
              },
            })
          })
        })
      }
    },
    saveReview(review) {
      const url = `${this.$readerURL}/admin/books/reviews/${review.id}`
      this.loader('block')
      const temp = this
      firebase.auth().currentUser.getIdToken(false).then(idToken => {
        axios.post(url, review,
          {
            headers: {
              Authorization: idToken,
            },
          }).then(response => {
          this.loader('none')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'success',
              icon: 'EditIcon',
              variant: 'success',
            },
          })

          temp.review.title = ''
          temp.review.description = ''
          temp.approved = false
          temp.rating = 0
          temp.id = undefined
          temp.$refs.reviewsTable.loadData()
          return response
        }).catch(error => {
          this.loader('none')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error,
              icon: 'EditIcon',
              variant: 'error',
            },
          })
        })
      })
    },
    addReview() {
      const newReview = {
        id: this.review.id,
        email: this.review.email,
        title: this.review.title,
        description: this.review.description,
        rating: this.review.rating,
        bookId: this.$route.params.book,
        approved: this.review.approved,
      }

      if (newReview.id !== undefined) {
        this.saveReview(newReview)
      } else {
        const url = `${this.$readerURL}/admin/books/${this.$route.params.book}/reviews`
        this.loader('block')
        const temp = this
        firebase.auth().currentUser.getIdToken(false).then(idToken => {
          axios.post(url, newReview,
            {
              headers: {
                Authorization: idToken,
              },
            }).then(response => {
            this.loader('none')
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'success',
                icon: 'EditIcon',
                variant: 'success',
              },
            })

            temp.review.title = ''
            temp.review.description = ''
            temp.approved = false
            temp.rating = 0
            temp.id = undefined
            temp.$refs.reviewsTable.loadData()
            return response
          }).catch(error => {
            this.loader('none')
            this.$toast({
              component: ToastificationContent,
              props: {
                title: error,
                icon: 'EditIcon',
                variant: 'error',
              },
            })
          })
        })
      }
    },
    askDelete() {
      this.$bvModal
        .msgBoxConfirm('Please confirm that you want to delete this book.', {
          title: 'Please Confirm',
          size: 'sm',
          okVariant: 'danger',
          okTitle: 'Delete',
          cancelTitle: 'Cancel',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if (value) {
            this.deleteBook()
          }
        })
    },
    deleteBook() {
      this.loader('block')
      const url = `${this.$readerURL}/admin/books/${this.$route.params.book}`
      firebase.auth().currentUser.getIdToken(false).then(idToken => {
        axios.delete(url,
          {
            headers: {
              Authorization: idToken,
            },
          }).then(response => {
          this.loader('none')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'success',
              icon: 'EditIcon',
              variant: 'success',
            },
          })
          this.$router.push('/books/')
          return response
        }).catch(error => {
          this.loader('none')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error,
              icon: 'EditIcon',
              variant: 'error',
            },
          })
        })
      })
    },
    sync() {
      this.loader('block')
      const url = `${this.$readerURL}/admin/books/${this.$route.params.book}/sync`
      firebase.auth().currentUser.getIdToken(false).then(idToken => {
        axios.get(url,
          {
            headers: {
              Authorization: idToken,
            },
          }).then(response => {
          this.loader('none')
          this.$bvModal
            .msgBoxOk('The sync will take up to 1 min.', {
              title: 'Info',
              size: 'sm',
              okVariant: 'primary',
              okTitle: 'Close',
              hideHeaderClose: false,
              centered: true,
            })

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'success',
              icon: 'EditIcon',
              variant: 'success',
            },
          })
          return response
        }).catch(error => {
          this.loader('none')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error,
              icon: 'EditIcon',
              variant: 'error',
            },
          })
        })
      })
    },
    clearCacheInternal(isSample) {
      const url = `${this.$readerURL}/admin/books/${this.$route.params.book}/clear-cache?sample=${isSample}`
      firebase.auth().currentUser.getIdToken(false).then(idToken => {
        axios.get(url,
          {
            headers: {
              Authorization: idToken,
            },
          }).then(response => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'success',
              icon: 'EditIcon',
              variant: 'success',
            },
          })
          return response
        }).catch(error => {
          this.loader('none')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error,
              icon: 'EditIcon',
              variant: 'error',
            },
          })
        })
      })
    },
    clearCache() {
      this.clearCacheInternal('false')
      this.clearCacheInternal('true')
    },
    saveBook() {
      const url = `${this.$readerURL}/admin/books/${this.$route.params.book}`
      this.loader('block')
      firebase.auth().currentUser.getIdToken(false).then(idToken => {
        axios.post(url, this.book,
          {
            headers: {
              Authorization: idToken,
            },
          }).then(response => {
          this.loader('none')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'success',
              icon: 'EditIcon',
              variant: 'success',
            },
          })
          return response
        }).catch(error => {
          this.loader('none')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error,
              icon: 'EditIcon',
              variant: 'error',
            },
          })
        })
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/quill.scss';
</style>
